<script lang="ts" setup>
import { SitePayloadLink } from '#components'

const props = defineProps<{
  node: Node,
  linkObjects?: any[],
  isFirst?: boolean,
  isLast?: boolean,
}>()

const VOID_ELEMENTS = new Set(['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'])

const getNodeType = (node: Node) => {
  if (node.rawTagName) {
    return 'element'
  }

  if (node.nodeType === 3) {
    return 'text'
  }
}

const getComponentForNode = (node: Node) => {
  if (node.rawTagName === 'a' && getLinkObjectForNode(node)) {
    return SitePayloadLink
  }

  return node.rawTagName
}

const getLinkObjectForNode = (node: any) => {
  if (node.rawTagName !== 'a') return null

  const obj =  props.linkObjects?.find(linkObject => {
    return linkObject?.id === node?.id
  })

  const textChildNode = node.childNodes?.find((childNode: Node) => childNode.nodeType === 3)
  const linkText = textChildNode?.rawText || null

  return {
    ...obj?.fields?.link,
    label: linkText,
    other: obj
  }
}
</script>

<template>
  <template v-if="getNodeType(props.node) === 'element'">
    <!-- Void elements cannot have children; rendering them with a slot causes hydration mismatch -->
    <component
      v-if="VOID_ELEMENTS.has(props.node.rawTagName)"
      :is="props.node.rawTagName"
      v-bind="props.node.attributes"
      :data-first-node="props.isFirst ? '' : null"
      :data-last-node="props.isLast ? '' : null"
    />
    <component
      v-else
      :is="getComponentForNode(props.node)"
      v-bind="getComponentForNode(props.node) === SitePayloadLink ? { data: getLinkObjectForNode(props.node), } : props.node.attributes"
      :data-first-node="props.isFirst ? '' : null"
      :data-last-node="props.isLast ? '' : null"
    >
      <core-rich-text-node
        v-for="(childNode, index) in props.node.childNodes"
        :key="index"
        :link-objects="props.linkObjects"
        :node="childNode"
      />
    </component>
  </template>

  <template
    v-else-if="getNodeType(props.node) === 'text'"
  >
    {{ props.node.innerText }}
  </template>
</template>
